import { useContext } from 'react';
import { Table, TableHead, TableBody, TableFooter, TableRow, TableCell, TablePagination, Typography } from '@material-ui/core';
import { PageContent, EditIconButton, DeleteIconButton } from 'components';
import { adminUsersContext } from '../AdminUsersContext';
import { applicationContext } from 'helpers/services/ApplicationContext';
import GeneratePassword from './GeneratePassword';
import { UserType } from 'helpers/enums';


let Results = () => {
    let appService = useContext(applicationContext);
    let service = useContext(adminUsersContext);


    return (
        <PageContent>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Email</TableCell>
                        <TableCell>Name</TableCell>
                        <TableCell>Company</TableCell>
                        <TableCell>Typology</TableCell>
                        <TableCell>Country</TableCell>
                        <TableCell size="small" />
                        <TableCell />
                    </TableRow>
                </TableHead>
                <TableBody>
                    {service.users.map(user =>
                        <TableRow hover key={user.id}>
                            <TableCell>{user.email}</TableCell>
                            <TableCell>{user.name}</TableCell>
                            <TableCell>{user.company}</TableCell>
                            <TableCell>{user.userType}</TableCell>
                            <TableCell>{appService.countries.getValueByKey(user.countryCode)}</TableCell>
                            <TableCell size="small">
                                {user.userType === UserType.External && user.existOnCognito === false &&
                                    <Typography variant="subtitle2" color='error'>Account missing from cognito</Typography>
                                }
                            </TableCell>
                            <TableCell align="right">
                                {user.userType === UserType.External && user.existOnCognito === true &&
                                    <GeneratePassword email={user.email} />
                                }
                                <EditIconButton size="small" link={`/adminuser/edit/${user.id}`} />
                                <DeleteIconButton onClick={() => service.deleteUser(user.id)} />
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
                {service.users.length === 0 &&
                    <TableFooter>
                        <TableRow>
                            <TableCell colSpan={5}>
                                <i>No users found</i>
                            </TableCell>
                        </TableRow>
                    </TableFooter>
                }
            </Table>
            <TablePagination
                component="div"
                rowsPerPageOptions={[service.search.pageSize]}
                count={service.recordCount}
                rowsPerPage={service.search.pageSize}
                page={service.search.pageNr}
                backIconButtonProps={{ 'aria-label': 'Previous Page' }}
                nextIconButtonProps={{ 'aria-label': 'Next Page' }}
                onPageChange={service.changePage}
                labelDisplayedRows={({ page }) =>
                    <span>Page {page + 1} of {Math.ceil(service.recordCount / service.search.pageSize)}</span>
                }
            />
        </PageContent>
    )
}

export default Results;